<template>
    <div class="page-wrap">
        <!-- Title and tabs stick together (same as NeedsApproval.vue) -->
        <div class="page-bar-sticky">
            <div class="page-bar">
                <div>
                    <div class="page-bar-sub">Foundations</div>
                    <div class="page-bar-main">Scoreboard</div>
                </div>
            </div>
            <div class="page-bar page-bar-toggles-wrap">
                <div class="page-bar-toggles">
                    <div :class="tab == 'scoreboard' ? 'page-bar-toggle-s' : ''" @click="setTab('scoreboard')">Scorecard</div>
                    <div :class="tab == 'rocks' ? 'page-bar-toggle-s' : ''" @click="setTab('rocks')">Rocks</div>
                    <div :class="tab == 'goals' ? 'page-bar-toggle-s' : ''" @click="setTab('goals')">Personal Goals</div>
                </div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <rocks-view v-if="tab == 'rocks'" />
            <personal-goals-view v-else-if="tab == 'goals'" />

            <scorecard-view v-else />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ScorecardView from '@/components/ScorecardView.vue';
import RocksView from '@/components/RocksView.vue';
import PersonalGoalsView from '@/components/PersonalGoalsView.vue';

export default defineComponent({
    name: 'TeamScoreboard',
    components: {
        ScorecardView,
        RocksView,
        PersonalGoalsView
    },
    created() {
        this.$store.state.routeLoaded = true;
    },
    computed: {
        // Scoreboard, Rocks or Personal Goals, from ?view= so the tab survives a reload
        tab(): string {
            return [ 'rocks', 'goals' ].includes(String(this.$route.query.view)) ? String(this.$route.query.view) : 'scoreboard';
        }
    },
    methods: {
        setTab(tab: string) {
            const query: any = { ...this.$route.query, view: tab == 'scoreboard' ? undefined : tab };
            if(tab != 'rocks') {
                delete query.quarter;
            }
            if(tab != 'goals') {
                delete query.person;
            }
            this.$router.replace({ query });
        }
    }
});
</script>
